<template>
	<ly-basemodel title="续费" :class="isShow? '' : 'hide'" v-ref:model>
		<form class="form-horizontal">
			<div class="form-group" style="margin-left:20px;">
                <label class="label-control col-sm-3" style="text-align: right;">门店名称:</label>
                <div>{{formdata.tradeName}}</div>
            </div>
            <div class="form-group" style="margin-left:20px;">
                <label class="label-control col-sm-3" style="text-align: right;">门店状态:</label>
                <div>{{formdata._type | statusfilter}}</div>
            </div>
            <div class="form-group" style="margin-left:20px;">
                <label class="label-control col-sm-3" style="text-align: right;">到期时间:</label>
                <div>{{formdata.data}}</div>
            </div> 
            <div class="form-group" style="margin-left:20px;">
                <label class="label-control col-sm-3" style="text-align: right;">本次延期时间:</label>
                <div>
                	<input v-model="formdata.number" style="background-color: #393e46;border:1px solid #ccc;border-radius: 4px;padding-left:4px;">
                	<select v-model="formdata.type" style="background-color: #393e46;width:50px;height:24px;border-radius: 4px;">
                		<option value="2">月</option>
                		<option value="1">日</option>
                	</select>
                	<label for="one" v-if="formdata._type== '-1'"><input id="one" type="checkbox" v-model="formdata.inputdata">从当前日期算起</label>
                </div>
            </div> 
            <div class="form-group" style="margin-left:20px;">
                <label class="label-control col-sm-3" style="text-align: right;">续费后到期时间:</label>
                <div>{{expire}}</div>
            </div>    
		</form>
		<button type="button" class="btn btn-primary" slot="button" @click="submit" >确定</button>
	</ly-basemodel>
</template>
<script>
	var Http = require('../../utils/HttpHelper.js');
	var Com = require('../../utils/Common.js');
	/*
	*  启用弹出框详情
	*/
	module.exports = {
		data:function(){
			return {
				formdata:{
					tradeName:'',//店名
					_type: 0,//状态
					data:'',//到期时间
					number:12,
					type:2,
					inputdata:false,//是否选择
				},
				expire:'',//续费后到期日期
				box: {},//存放当前管理公司信息
				show: function(){
                    this.$refs.model.show();
                },
                close: function() {
                    this.$refs.model.close();
                }
			}
		},
		props:['renew'],
		computeds: {
		},
		filters: {
			statusfilter:function(str){
				var out = '';
				switch(str){
					case 1:
						out = '正常';
						break;
					case 0:
						out = '停用';
						break;
					case -1:
						out = '过期';
						break;
				}
				return out;
			}
		},
		ready:function(){
			var self = this;
			this.$watch("renew",function(){
				this.box = JSON.parse(this.renew);
				this.formdata.tradeName = this.box.name;
				this.formdata._type = this.box.status;
				this.formdata.data = this.box.expiration_time || this.box.expire;
				this.countDate(self,self.formdata.data,self.formdata.number,self.formdata.type,self.formdata.inputdata,self.formdata._type);//初始化
				this.$watch("formdata.type",function(){
					self.expire = '';
					self.countDate(self,self.formdata.data,self.formdata.number,self.formdata.type,self.formdata.inputdata,self.formdata._type);
				});
				this.$watch("formdata.number",function(){
					if(!self.formdata.number){
						self.formdata.number = 0;
					}
					self.expire = '';
					self.countDate(self,self.formdata.data,self.formdata.number,self.formdata.type,self.formdata.inputdata,self.formdata._type);
				});
				this.$watch("formdata.inputdata",function(){
					self.expire = '';
					self.countDate(self,self.formdata.data,self.formdata.number,self.formdata.type,self.formdata.inputdata,self.formdata._type);
				})
			})	
		},
		methods:{
			/*
			* 计算到期日期
			* @self 当前模块对象
			* @_data 当前店铺到期时间
			* @number 续费的数量
			* @type  选择的月、日
			* @inputdata 是否从当前日期算起
			* @_type 是否是过期
			*/
			countDate:function(self,_data,number,type,inputdata,_type){
				if(_data){
					var data = _data.replace(/-/g,'/');
					if(inputdata){//从当前日期算起/过期  || _type == -1
						var nd = new Date();
					}else{
						var nd = new Date(data);
					};
					if(type ==2){
						if(number >60 || number < 0){
							number = 12;
							nd.setMonth(nd.getMonth()+parseInt(number));
						}else{
							if(!number){
								number = 0;
							};
							nd.setMonth(nd.getMonth()+parseInt(number));
						};	
					};
					if(type ==1){
						if(number >1830 || number < 0){
							number = 365;
							nd.setDate(nd.getDate()+parseInt(number));
						}else{
							if(!number){
								number = 0;
							}
							nd.setDate(nd.getDate()+parseInt(number));
						}	;	
					};
					if(!number){
						self.expire = _data;
						return;
					}
					var y = nd.getFullYear();  
					var m = nd.getMonth()+1;  
					var d = nd.getDate();  
					if(m <= 9) m = "0"+m;  
					if(d <= 9) d = "0"+d;   
					self.expire = y+"-"+m+"-"+d;
				}	
			},
			/*
			* 确定提交
			*/
			submit:function(){
				//this.$emit('newRenewals',this.expire);
				var self = this; 
				var data_ = {
					company_id:this.box.id,//id
					expiration_time:this.expire,//续费后的到期时间
					renewal_time:this.formdata.number,//续费时间长度
					renewal_time_unit:this.formdata.type,//续费时间单位
					is_current_start:this.formdata.inputdata?1:0,
				};
				Http['renewal'].create({
					key:[],
					data:data_,
					succ:function(rs){
						self.close();
						Com.tipDialog('续费成功！',1000,'success');
						self.$dispatch('newRenewal',rs)//返回给父组件
					},
					err:function(msg){
						self.close();
						Com.tipDialog('续费失败！',1000,'error');
					}
				});
				
			}
		},
		components:{
            'ly-basemodel':require('../popups/BaseModel.vue'),
        }
	}
</script>


/** WEBPACK FOOTER **
 ** Renewals.vue?1a6dcedf
 **/